import styled from "styled-components";

export const NewUserWrap = styled.div`
  .user-fields {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    margin-bottom: 20px;
    @media (min-width: 768px) {
      gap: 20px;
      grid-template-columns: repeat(2, 1fr);
    }
  }
  .btn-holder {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }
  .image-wrap {
    position: relative;
    max-width: 160px;
    height: 160px;
    margin: 0 auto 30px;
    img {
      border-radius: 50%;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top;
    }
    .edit-icon {
      cursor: pointer;
      position: absolute;
      bottom: 0;
      right: 5px;
      background-color: ${({ theme }) => theme?.light?.primary};
      width: 32px;
      height: 32px;
      padding: 5px;
      color: #ffffff;
      border-radius: 10px;
    }
  }
`;
